module.exports = __webpack_public_path__ + "images/bug_green_size_6_d0ec43cd68e0e086d1567b8dc55ca3bf.png";